import { TextSelection } from "prosemirror-state";
import { checkSpaceAutoremoval } from "./plugins";
export function mentionSuggester(name, prefix, registry) {
    return {
        name,
        noDecorations: true,
        char: prefix,
        supportedCharacters: /[\d\w][^/]*/,
        createCommand: ({ match, view }) => {
            return (target) => {
                createMention(match, view, target, prefix);
                view.focus();
            };
        },
        ...registry.callbacks,
    };
}
export function createMention(match, view, target, prefix) {
    const { from, to } = match.range;
    const schema = view.state.schema;
    const mention = schema.nodes.mention.create({
        id: target.id,
        title: target.title,
        application: target.application,
        prefix,
    });
    const tr = view.state.tr;
    tr.replaceRangeWith(from, to, mention);
    tr.setSelection(new TextSelection(tr.doc.resolve(from + 1)));
    tr.insertText(" ");
    checkSpaceAutoremoval(tr);
    view.dispatch(tr);
}
